import { useCurrentUser } from '@framework/auth/state/AuthSlice.tsx';
import { useLastLoginMenuItem } from '@framework/common-web/ui/user-menu/useLastLoginMenuItem.tsx';
import { Dropdown } from '@framework/ui/components/dropdown/Dropdown.tsx';
import { useMemo } from 'react';
import { FrontUserButton } from './FrontUserButton.tsx';
import { LoginButton } from './LoginButton.tsx';
import { useUserMenuItems } from './useUserMenuItems.tsx';

export interface UserMenuProps {
  isMobile?: boolean | null;
}
/**
 * Pulsante Dropdown per il logout dell'utente lato compilazione
 * Visualizza il nome dell'utente loggato.
 */
export function UserMenu(props: UserMenuProps) {
  const { isMobile } = props;
  const currentUser = useCurrentUser();
  const userMenuItem = useUserMenuItems();
  const { lastLoginMenuItem, lastLoginsDrawer } = useLastLoginMenuItem();

  const menu = useMemo(
    () => ({
      items: [lastLoginMenuItem, ...userMenuItem.items],
    }),
    [lastLoginMenuItem, userMenuItem.items],
  );

  return currentUser ? (
    <>
      <Dropdown
        autoFocus
        placement="bottomRight"
        menu={menu}
        trigger={['click']}
      >
        <FrontUserButton currentUser={currentUser} isMobile={isMobile} />
      </Dropdown>
      {lastLoginsDrawer}
    </>
  ) : (
    <LoginButton />
  );
}
